var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgArrowBorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 49,
  height: 40,
  viewBox: "0 0 49 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.214 9.999A.78.78 0 0 1 26 9.956V7h-7.5C10.492 7 4 13.492 4 21.5S10.492 36 18.5 36h12C38.508 36 45 29.508 45 21.5v-.593a11.791 11.791 0 0 0 4-1.244V21.5c0 9.712-7.484 17.676-17 18.44V40H18.5C8.283 40 0 31.717 0 21.5S8.283 3 18.5 3H26V.044a.78.78 0 0 1 .751.13l5 4.294a.687.687 0 0 1 0 1.064l-5 4.293a.773.773 0 0 1-.537.174Z",
  fill: "url(#b)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 24.5,
  y1: 0,
  x2: 24.5,
  y2: 40,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2DFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5B83"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h49v40H0z"
})))));

export default SvgArrowBorder;